import { useNavigate } from 'react-router-dom'
import { Button, Typography, Box, Stack } from '@mui/material'
import { useIsMobile } from '@/hooks/Responsive'
import { useLang } from '@/i18n/useLang'
import { buildLangHref } from '@data/nav'

export default function Step5({ MemberType, type, memberInfo }) {
  const { isMobile } = useIsMobile()
  const lang = useLang() 
  const navigate = useNavigate();

  const isInstitute = type === MemberType.INST;  //기관가입여부


  return (
    <Box>
      <Stack 
        alignItems="center" 
        justifyContent="center"
        sx={{
          textAlign: 'center',
          pt: 10,
        }}
      >
        {/* 동그란 아이콘 배경 */}
        <Box
          sx={{
            width: '64px',
            height: '64px',
            borderRadius: '50%',
            bgcolor: 'primary.50',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 4,
            flexShrink: 0,
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="20" viewBox="0 0 28 20" fill="none">
            <path d="M2 9.80488L10.129 18L26 2" stroke="#FA6700" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </Box>
  
        <Typography variant={isMobile ? 'subtitle2' : 'subtitle1'} fontWeight={500} sx={{ mb: 1.5 }}>
          OpenVLab 가입을 환영합니다.
        </Typography>
  
        <Typography color="text.secondary">
           지금 바로 OpenVLab의 다양한 XR콘텐츠 및 강좌를 체험해 보세요.<br />
           {isInstitute && (
              <>
                <Typography variant="span" color="text.secondary">{memberInfo?.instName || "기관"}</Typography>{' '}
                 <Typography variant="span" color="text.secondary">관리자 승인 후 기관학습자 가입이 완료됩니다.</Typography>
              </>
            )}
        </Typography>
      </Stack>

      {/* {isInstitute ? (
      <>
      {/* 기관학습자 */}
      {/* <Typography
        component="h2"
        variant={isMobile ? 'h3' : 'h2'}
        sx={{ mt: 4, color: (theme) => theme.palette.primary.main }}
        gutterBottom
      >
        “OpenVLab 기관학습자 가입이 신청되었습니다.”
      </Typography>
      <Typography variant={isMobile ? 'h6' : 'h5'} sx={{ textAlign: 'center' }} gutterBottom>
        {memberInfo?.instName || "기관"} 관리자 승인 후 기관학습자 회원가입이 완료 됩니다.
      </Typography>
      </>
      ) : (
      <> */}
      {/* 일반학습자 */}
      {/* <Typography
        component="h2"
        variant={isMobile ? 'h3' : 'h2'}
        sx={{ mt: 4, color: (theme) => theme.palette.primary.main }}
        gutterBottom
      >
        “오픈브이랩 회원가입을 환영합니다.”
      </Typography>
      <Typography variant={isMobile ? 'h6' : 'h5'} sx={{ textAlign: 'center' }} gutterBottom>
        지금 바로 다양한 XR콘텐츠 및 강좌를 체험해 보세요.
      </Typography>
      </>
      )} */} 

      {/* 기관학습자(계정등록후) */}
      {/* <Typography
        component="h2"
        variant={isMobile ? 'h3' : 'h2'}
        sx={{ mt: 4, color: (theme) => theme.palette.primary.main }}
        gutterBottom
      >
        “OpenVLab 기관학습자 가입이 완료되었습니다.”
      </Typography>
      <Typography variant={isMobile ? 'h6' : 'h5'} sx={{ textAlign: 'center' }} gutterBottom>
        '경북대학교'의 '근육의 작용' 강좌에 대한<br />
        수강 권한이 부여되었습니다.<br />
        수강신청을 완료하시면<br />
        바로 강의를 들으실 수 있습니다.
      </Typography> */}

      <Stack alignItems="center" sx={{ mt: 7 }}>
        <Button
          size="large"
          variant="contained"
          color="primary"
          onClick={() => navigate(buildLangHref('/login', lang))}
          sx={{
            width: isMobile ? '100%' : '160px'
          }}
        >
          로그인
        </Button>
      </Stack>
    </Box>
  )
}